// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_quantity_unit_enum */
var InvQuantityUnitEnum;
(function (InvQuantityUnitEnum) {
    InvQuantityUnitEnum["mg"] = "mg";
    InvQuantityUnitEnum["g"] = "g";
    InvQuantityUnitEnum["kg"] = "kg";
    InvQuantityUnitEnum["mL"] = "mL";
    InvQuantityUnitEnum["L"] = "L";
})(InvQuantityUnitEnum || (InvQuantityUnitEnum = {}));
;
export default InvQuantityUnitEnum;
/** Zod schema for inv_quantity_unit_enum */
export const invQuantityUnitEnum = z.nativeEnum(InvQuantityUnitEnum);
//# sourceMappingURL=InvQuantityUnitEnum.js.map